import { HttpResponse } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { RnCatalogItemVM } from "src/app/core/models/catalogItemVM-d";
import {
  OrderService,
  OrganizationService,
  RnCommonId,
  RnOrganizationsProfileVM,
  RnRNAddOnPayload,
  RnRNLicenseItem,
  RnRNOrderHeader,
  RnRNOrderItem,
} from "src/app/shared/services/rnapi2-service";
import { RnsidebarService } from "src/app/shared/services/sidebar/rnsidebar.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoggedInInfoService } from "src/app/shared/services/loggedInInfo/logged-in-info.service";
import { IdService } from "src/app/shared/services/id/id.service";
import { SelectionService } from "src/app/shared/services/selection/selection.service";
import { RnRNModifyVendorAccountItem } from "src/app/shared/services/rnapi2-service/models/rNModifyVendorAccountItem-d";
import { RnRNModifyVendorAccountPayload } from "src/app/shared/services/rnapi2-service/models/rNModifyVendorAccountPayload-d";
import { RnRNModifyVendorSubscriptionPayload } from "src/app/shared/services/rnapi2-service/models/rNModifyVendorSubscriptionPayload-d";
import { RnRNModifyVendorSubscriptionItem } from "src/app/shared/services/rnapi2-service/models/rNModifyVendorSubscriptionItem-d";
import { ToasterService, ToastType } from "@rn-platform/frontend-shared-data-access-toaster";
import { FormSteps } from "../../../form-steps/form-steps";
import { StepInfo } from "../../../form-steps/step-info";
import { ModalComponent } from "@rn-platform/frontend-shared-ui-common";
import { QBOSubscriptionModalService } from "./qbo-subscription-modal.service";
import { QBOSubscriptionData } from "./qbo-subscription.data";

@Component({
    selector: "app-qbo-subscription",
    templateUrl: "./qbo-subscription.component.html",
    styleUrls: ["./qbo-subscription.component.scss"],
    standalone: false
})
export class QboSubscriptionComponent implements OnInit, OnDestroy {
  private readonly organizationService = inject(OrganizationService);
  private readonly rnsidebarService = inject(RnsidebarService);
  private readonly loggedInInfoService = inject(LoggedInInfoService);
  private readonly orderService = inject(OrderService);
  private readonly toasterService = inject(ToasterService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly selectionService = inject(SelectionService);

  @ViewChild('modalRef') modalComponent: ModalComponent;
  private readonly qboSubModalService = inject(QBOSubscriptionModalService);
  @Output() componentLoaded = new EventEmitter<boolean>();
  @Output() QboPlansSelected = new EventEmitter<any>();
  @Output() QboPayrollSelected = new EventEmitter<any>();
  @Output() QboTimeSelected = new EventEmitter<any>();
  @Input() set additionalData(any) {
    if (any !== null && any !== undefined) {
      this.qboAccountID = any;
    }
  }
  private qboSubData: QBOSubscriptionData;
  private subscriptions: Subscription[] = [];
  public addons: RnCatalogItemVM[] = [];
  public formIsLoading = true;
  public isPayrolleliteOrPremium = false;
  public existingItem: any = null;
  public isChangeSubscription = false;
  public isAddOnAttach = false;
  public qboAccountID?: string;
  public iDontNeedPayroll = false;
  public iDontNeedTime = false;
  public mainForm: FormGroup;
  public isProcessing = false;
  public startingStep = 0;
  public checkoutData = [];
  public QboTimeData = [];
  public QboPlansData = [];
  public QboPayrollData = [];
  public SelectedPlan: any;
  public orgProfile: RnOrganizationsProfileVM;
  public formSteps: FormSteps;
  public qboPlansAddonsList = [];
  public qboTimeAddonsList = [];
  public qboPayrollAddonsList = [];
  public childrenData = [];
  public hasBeenInitialized: boolean = false;
  constructor() {
    this.subscriptions.push(
      this.selectionService.SelectedOrgProfile.subscribe((p) => {
        this.orgProfile = p;
      }),
    );
  }

  ngOnInit(): void {
    const modalSub = this.qboSubModalService.modalState$.subscribe(data => {
    if(data?.config){
          this.qboSubData = data.config;
          this.qboAccountID = data.config.ID;
          this.formSteps = this.generateFormSteps();
          this.orgProfile = data.config.organization;  
          this.initializeQBOSubscriptions();
          this.formSteps.setStartingIndex(data.config.startingStep);
          this.mainForm = this.generateMainForm();
          this.toggleStepEnabledment();
          this.hasBeenInitialized = true;
    }
    else{
      return;
    }
    this.setInitialQBOData(data);
    if (data.isOpen) {
      this.open();
    }
    else {
      this.close();
    }
    });
    this.subscriptions.push(modalSub);
    this.componentLoaded.emit(true);
  }

  public setInitialQBOData(data): void {
    if(data.config.ID){
      this.qboAccountID = data.config.ID;
    }
    if(data.config.isAddOnAttach){
      this.isAddOnAttach = data.config.isAddOnAttach;
    }
  }


  public generateMainForm(): FormGroup {
    return this.formBuilder.group({
      QboPlans: this.formBuilder.group({
        QboPlansSelected: ["", Validators.required.bind(Validators)],
      }),
      QboPayroll: this.formBuilder.group({
        QboPayrollSelected: ["", Validators.required.bind(Validators)],
      }),
      QboTime: this.formBuilder.group({
        QboTimeSelected: ["", Validators.required.bind(Validators)],
      }),
      QboCheckout: this.formBuilder.group({}),
      QboConfirmation: this.formBuilder.group({}),
    });
  }

  initializeQBOSubscriptions() {
    this.loadPackagesData(this.orgProfile.ID.toString()).subscribe((resp) => {
      const result = resp.body.data.Addons;
      this.QboTimeData = result.filter((el) => {
        return el.CatalogCategoryName === "QBOTimeAddons";
      });
      this.QboTimeData.forEach((x) => {
        this.qboTimeAddonsList.push(x.SKU);
        this.childrenData.push(x.SKU);
        if (x.SKU === "QB-TIME-EL") {
          x.PackageCategoryName = "Elite";
        } else if (x.SKU === "QB-TIME-PREM") {
          x.PackageCategoryName = "Premium";
        } else {
          x.PackageCategoryName = x.PackageName;
        }
      });
      this.QboTimeData = this.QboTimeData.sort(
        (a, b) => b.NextBillPrice - a.NextBillPrice,
      );
      this.QboPlansData = result.filter((el) => {
        return el.CatalogCategoryName === "OSQBOAddOns";
      });
      this.QboPlansData.forEach((x) => {
        this.qboPlansAddonsList.push(x.SKU);
        if (x.SKU === "OS-QBO-ADV") {
          x.PackageCategoryName = "Advanced";
        } else if (x.SKU === "OS-QBO-PLUS") {
          x.PackageCategoryName = "Plus";
        } else if (x.SKU === "OS-QBO-ESSTLS") {
          x.PackageCategoryName = "Essentials";
        } else if (x.SKU === "OS-QBO-SS") {
          x.PackageCategoryName = "Simple Start";
        } else {
          x.PackageCategoryName = x.PackageName;
        }
      });
      this.QboPlansData = this.QboPlansData.sort(
        (a, b) => b.NextBillPrice - a.NextBillPrice,
      );

      this.QboPayrollData = result.filter((el) => {
        return el.CatalogCategoryName === "QBOPayrollAddons";
      });
      this.QboPayrollData.forEach((x) => {
        this.qboPayrollAddonsList.push(x.SKU);
        this.childrenData.push(x.SKU);
        if (x.SKU === "QBO-EL-PR") {
          x.PackageCategoryName = "Elite";
        } else if (x.SKU === "QBO-PREM-PR") {
          x.PackageCategoryName = "Premium";
        } else if (x.SKU === "QBO-CORE-PR") {
          x.PackageCategoryName = "Core";
        } else {
          x.PackageCategoryName = x.PackageName;
        }
      });
      this.QboPayrollData = this.QboPayrollData.sort(
        (a, b) => b.NextBillPrice - a.NextBillPrice,
      );
      this.formIsLoading = false;
    });
  }

  public getTitle(){
    return this.formSteps?.getActiveStep()?.title ?? "QuickBooks Online";
  }

  generateFormSteps(): FormSteps {
    const steps: FormSteps = new FormSteps();
    const QboPlans: StepInfo  = new StepInfo();
      QboPlans.ID= "QboPlans";
      QboPlans.title= "Choose the Right QuickBooks Online Plan for You";
      QboPlans.formName= "QboPlans";
      QboPlans.btnText= "NEXT";
      QboPlans.desc= "Each plan comes with our world-class support and data migration.";
    steps.push(QboPlans);
    const QboPayroll: StepInfo  = new StepInfo();
      QboPayroll.ID= "QboPayroll";
      QboPayroll.title= "Add QuickBooks Payroll";
      QboPayroll.formName= "QboPayroll";
      QboPayroll.btnText= "NEXT";
      QboPayroll.desc= "Select your plan; and manage your payroll right from QuickBooks online.";
    steps.push(QboPayroll);
    const QboTime: StepInfo  = new StepInfo();
      QboTime.ID= "QboTime";
      QboTime.title= "Add QuickBooks Time";
      QboTime.formName= "QboTime";
      QboTime.btnText= "NEXT";
      QboTime.desc= "Select a QuickBooks Time plan; and easily manage time tracking for your business.";
    steps.push(QboTime);
    const QboCheckout: StepInfo  = new StepInfo();
      QboCheckout.ID= "QboCheckout";
      QboCheckout.title= "Check Out";
      QboCheckout.formName= "QboCheckout";
      QboCheckout.btnText= "PURCHASE SUBSCRIPTION";
      QboCheckout.desc= "Purchase your customized QuickBooks Online package below and get started.";
    steps.push(QboCheckout);
    const QboConfirmation: StepInfo  = new StepInfo();
      QboConfirmation.ID= "QboConfirmation";
      QboConfirmation.title= "Purchase Confirmation";
      QboConfirmation.formName= "QboConfirmation";
      QboConfirmation.btnText= "FINISH";
      QboConfirmation.desc= "Thank you for your purchase. You can manage your plan on the QuickBooks tab in AppHub; and reach out to support at any time.";
    steps.push(QboConfirmation);
    return steps;
  }

  public toggleStepEnabledment(){
    const itemName = this.qboSubData.selectedItem?.Name?.trim();
    if(!itemName){
      return;
    }
    switch(itemName){
      case ("addPayrollOrTime"):
        this.formSteps.disableStepByIndex(0);
        this.startingStep = 1;
        this.isAddOnAttach = true;
        break;
      case("QuickBooks Online"):
        this.startingStep = 0;
        this.isChangeSubscription = true;
        this.existingItem = this.qboSubData.selectedItem;
        this.formSteps.disableStepByIndex(1);
        this.formSteps.disableStepByIndex(2);
        break;
      case("QuickBooks Online Payroll"):
        this.formSteps.disableStepByIndex(0);
        this.formSteps.disableStepByIndex(2);
        this.startingStep = 1;
        this.isChangeSubscription = true;
                this.existingItem = this.qboSubData.selectedItem;
        break;
      case("QuickBooks Time"):
        this.formSteps.disableStepByIndex(0);
        this.formSteps.disableStepByIndex(1);
        this.startingStep = 2;
        this.isChangeSubscription = true;
                this.existingItem = this.qboSubData.selectedItem;
        break;
    }
    this.formSteps.activeIndex = this.startingStep;
  }


  qboPlanSelected(plan: any) {
    this.QboPlansSelected.emit(plan);
    this.formSteps.getStepByID("QboPlans").btnEnabled = true;
    if (this.checkoutData.length > 0) {
      this.checkoutData = this.checkoutData.filter((el) => {
        return this.childrenData.includes(el.PackageSKU);
      });
      this.checkoutData.push(plan);
    } else {
      this.checkoutData.push(plan);
    }

    this.checkoutData = this.checkoutData.slice();
  }

  qboPayrollSelected(payroll: any) {
    this.QboPayrollSelected.emit(payroll);
    this.formSteps.getStepByID("QboPayroll").btnEnabled = true;
    if (payroll === 100) {
      this.iDontNeedPayroll = true;
      this.formSteps.getStepByID("QboTime").enabled = true;
      this.isPayrolleliteOrPremium = false;
      this.checkoutData = this.checkoutData.filter(
        (a) => !this.qboPayrollAddonsList.includes(a.SKU),
      );
    } else {
      this.iDontNeedPayroll = false;
      this.formSteps.getStepByID("QboTime").enabled = false;
    }

    if (this.qboPayrollAddonsList.includes(payroll.SKU)) {
      this.checkoutData = this.checkoutData.filter(
        (a) =>
          !this.qboPayrollAddonsList.includes(a.SKU) &&
          !this.qboTimeAddonsList.includes(a.SKU),
      );
      this.checkoutData.push(payroll);
      this.isPayrolleliteOrPremium = true;
    }
  }

  qboTimeSelected(time: any) {
    this.QboTimeSelected.emit(time);
    this.formSteps.getStepByID("QboTime").btnEnabled = true;
    if (time === 100) {
      this.iDontNeedTime = true;
      this.formSteps.getStepByID("QboPayroll").enabled = true;
      this.checkoutData = this.checkoutData.filter(
        (a) => !this.qboTimeAddonsList.includes(a.SKU),
      );
    } else {
      this.iDontNeedTime = false;
      this.formSteps.getStepByID("QboPayroll").enabled = false;
    }

    if (this.qboTimeAddonsList.includes(time.SKU)) {
      this.checkoutData = this.checkoutData.filter(
        (a) =>
          !this.qboPayrollAddonsList.includes(a.SKU) &&
          !this.qboTimeAddonsList.includes(a.SKU),
      );
      this.checkoutData.push(time);
    }

    this.checkoutData = this.checkoutData.filter((el) => {
      return el.PackageName !== "iDontNeedTime";
    });
  }

  getOrderItems(selectedItem: any) {
    const orderItems = [];
    for (const item of selectedItem) {
      const o: RnRNOrderItem = {
        PackageID: item.PackageID,
        Quantity: 1,
        PromoCode: "-1",
      };
      orderItems.push(o);
    }
    return orderItems;
  }

  getModifyVendorAccountItems(selectedItem: any) {
    const orderItems = [];
    for (const item of selectedItem) {
      const o: RnRNModifyVendorAccountItem = {
        AccountId: this.qboAccountID,
        PackageID: item.PackageID,
      };
      orderItems.push(o);
    }
    return orderItems;
  }

  getModifyVendorSubscriptionItems(selectedItem: any) {
    const orderItems = [];
    for (const item of selectedItem) {
      const o: RnRNModifyVendorSubscriptionItem = {
        VendorAccountID: this.qboAccountID.split(":")[0],
        VendorBaseSubscriptionID: this.qboAccountID.split(":")[1],
        PackageID: item.PackageID,
      };
      orderItems.push(o);
    }
    return orderItems;
  }

  confirmSaveChanges(selectedItem: any) {
    const loggedInUser = this.loggedInInfoService.GetLoggedInUser();
    if (!loggedInUser) {
      return;
    }
    if (this.isAddOnAttach) {
      //to used for add-on
      if (!this.qboAccountID) {
        const message = 'QBO Account ID is missing. Cannot process the order.';
        const id = 'apphub-qbo-subscription-missing-account-id-error-toast';
        this.toasterService.addToast(ToastType.Error_, message, message, id, id);
        return;
      }
      this.isProcessing = true;
      const payload: RnRNModifyVendorAccountPayload =
        new RnRNModifyVendorAccountPayload();
      payload.VendorName = "Intuit_QBO";
      payload.AffectedOrganizationId = this.orgProfile.ID;
      payload.Items = this.getModifyVendorAccountItems(selectedItem);
      this.orderService
        .apiV2OrdersModifyvendorAccountPost(payload, "response")
        .subscribe({
          next: (response) => {
            if (response?.body?.Success) {
              this.isProcessing = false;
              this.rnsidebarService.setPendingChanges(false);
              this.close();
            }            
          },
          error: (error) => {
            this.isProcessing = false;
            this.rnsidebarService.setPendingChanges(false);
            const message = error.error.Messages[0].Description;
            const id = 'apphub-qbo-purchase-order-process-error-toast';
            this.toasterService.addToast(ToastType.Error_, message, message, id, id);
          },
        });
    } else if (this.isChangeSubscription && this.existingItem) {
      //to used for upgrade/downgrade
      const payload: RnRNModifyVendorSubscriptionPayload =
        new RnRNModifyVendorSubscriptionPayload();
      payload.VendorName = "Intuit_QBO";
      payload.AffectedOrganizationId = this.orgProfile.ID;
      payload.Items = this.getModifyVendorSubscriptionItems(selectedItem);
      this.orderService
        .apiV2OrdersModifyvendorSubscriptionPost(payload, "response")
        .subscribe({ next: (response) => {
          this.isProcessing = false;
          this.rnsidebarService.setPendingChanges(false);
          if (response?.body?.Success) {
            this.close();
          }
        },
        error: (error) => {
            this.isProcessing = false;
            this.rnsidebarService.setPendingChanges(false);
            const message = error.error.Messages[0].Description;
            const id = 'apphub-qbo-purchase-order-process-error-toast';
            this.toasterService.addToast(ToastType.Error_, message, message, id, id);
        }
      });
    } else {
      //to used for add
      const payload: RnRNAddOnPayload = new RnRNAddOnPayload();
      payload.PaymentOnFileID =
        this.loggedInInfoService.GetLoggedInUserOrg().PaymentOnFileID;
      payload.OrganizationID = this.orgProfile.ID;
      payload.OrderItems = this.getOrderItems(selectedItem);
      payload.QbesLicenseItems = new Array<RnRNLicenseItem>();
      payload.PromotionCodeID = null;
      payload.ForceSkipEmail = false;
      const header: RnRNOrderHeader = {
        Order_XID: IdService.makeID(),
        Order_Source: "AppHub",
        Order_Date: new Date().toISOString().slice(0, 10).replace(/-/g, "/"),
        SalesAgent_TAG: loggedInUser.UserID.toString(),
      };
      payload.Header = header;
      this.orderService
        .apiV2OrdersCreateaddonPost(payload, "response")
        .subscribe({
          next: (response) => {
            this.isProcessing = false;
            this.rnsidebarService.setPendingChanges(false);
            if (response?.body?.Success) {
              this.close();
            }
          },
          error: (error) => {
            this.isProcessing = false;
            this.rnsidebarService.setPendingChanges(false);
            const message = error.error.Messages[0].Description;
            const id = 'apphub-qbo-purchase-order-process-error-toast';
            this.toasterService.addToast(ToastType.Error_, message, message, id, id);
          }
        });
    }
  }

  processing(): boolean {
    return this.isProcessing;
  }

  public handleNext(): void {
    if(this.formSteps.isLastStep() || this.formSteps.getActiveStep().ID === "QboConfirmation"){
      if(!this.isProcessing){
        this.close();
      }
    }
    if (this.formSteps.getActiveStep().ID === "QboCheckout") {
      this.isProcessing = true;
      this.processing();
      this.confirmSaveChanges(this.checkoutData);
    }
    {
      let nextIndex: number = this.formSteps.activeIndex + 1;
      while (!this.canNavigateToStep(nextIndex)) {
        if(this.formSteps.isLastStep(nextIndex)){
            break;
        }
        nextIndex++;
      }
      this.formSteps.activeIndex = nextIndex;
    }
  }

  canNavigateToStep(stepIdx: number): boolean {
    const nextStep = this.formSteps.getStepByIndex(stepIdx);
    if(!nextStep) {
      return false;
    }
    const currentID: string = this.formSteps.getActiveStep().ID;
    switch (currentID) {
          case "QboPlans":
            return nextStep.enabled;
          case "QboPayroll":
            return nextStep.enabled;
          case "QboTime":
             return nextStep.enabled && ( 
              ((!this.isPayrolleliteOrPremium || this.iDontNeedPayroll) &&
                !this.isChangeSubscription) ||
              (this.existingItem != null &&
                this.existingItem.Name === "QuickBooks Time")
            );
          case "QboCheckout":
            nextStep.enabled =  true;
            return nextStep.enabled;
          case "QboConfirmation":
            nextStep.enabled =  true;
            return nextStep.enabled;
          default: return true;
      }
  }


  public handlePrevious(): void{
    const previousValidIndex: number = this.formSteps.getPreviousValidIndex();
    if(this.backEnabled()){
      this.formSteps.activeIndex = previousValidIndex;
    }
  }

  public backEnabled(): boolean{
    if(this.formSteps.activeIndex <= this.startingStep){
      return false;
    }
    const currentID: string = this.formSteps.getActiveStep().ID;
    switch (currentID) {
        case "QboCheckout":
          return true;
        case "QboConfirmation":
          return false;
        default:
          return this.hasValidPreviousStep();
    } 
  }

  public hasValidPreviousStep(){
    const previousValidIndex = this.formSteps.getPreviousValidIndex();
    const currentIndex = this.formSteps.activeIndex;
    return (this.formSteps.isFirstStep() || !this.isProcessing && previousValidIndex < currentIndex);
  }



  public isNextEnabled(): boolean {
    switch(this.formSteps.activeIndex){
      case 3: 
        return this.checkoutData.length > 0;
      case 4:
        return true;
      default:
        return this.formSteps.getActiveStep().btnEnabled;
    }
  }
 
  public close(): void {
    this.clearData();
    this.modalComponent?.close();
  }

  public clearData(): void{
    this.QboTimeData = [];
    this.QboPlansData = [];
    this.QboPayrollData = [];
    this.formIsLoading = false;
    this.checkoutData = [];
    this.formIsLoading = false;
    this.isPayrolleliteOrPremium = false;
    this.existingItem = null;
    this.isChangeSubscription = false;
    this.isAddOnAttach = false;
    this.iDontNeedPayroll = false;
    this.iDontNeedTime = false;
    this.isProcessing = false;
    this.startingStep = 0;
    this.qboSubData?.clear();
  }


  public open(): void {
    this.modalComponent?.open();
  }


  public isQBOPayRollStepEnabled(): boolean {
    return ( !this.isChangeSubscription || 
      (this.existingItem != null && this.existingItem.Name === "QuickBooks Online Payroll") );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public loadPackagesData(orgId: string): Observable<HttpResponse<any>> {
    const payload = new RnCommonId();
    payload.Id = orgId;
    return this.organizationService.apiV2OrganizationsGetallcatalogitemsfororgPost(
      payload,
      "response",
    );
  }

  onSidebarClose(): void {
    this.rnsidebarService.refreshUser();
  }
}
export interface checkoutData {
  Item: string;
  MonthlyCost: string;
}
